import * as React from 'react';
import styled from 'styled-components';

import { ContainerLarge } from '@app/components/WebTemplates/components';
import { Devices } from '@app/styles';

const Loader = (): React.ReactElement => (
  <Container>
    <LoaderWrapper>
      <div />
      <div />
      <div />
      <div />
    </LoaderWrapper>
  </Container>
);

const Container = styled(ContainerLarge)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100px 0;
  height: 100%;

  @media ${Devices.tablet} {
    padding: 200px 0;
  }
`;

const LoaderWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  & div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${(props): string => props.theme.color.harleyDavidsonOrange} transparent transparent transparent;
  }

  & div:nth-child(1) {
    animation-delay: -0.45s;
  }

  & div:nth-child(2) {
    animation-delay: -0.3s;
  }

  & div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default Loader;
